"use client";

import {
  BookEyeTestContent,
  BookingDetails,
  EyeTestServiceType,
  StoreType,
  TranslationData,
} from "@/common/lib/types";
import BookEyeTestLayout, { BookEyeTestLayoutRef } from "@/layouts/BookEyeTestLayout";
import { useState, useRef } from "react";
import Modal from "../ui/modal_new/Modal";
import EyeTestHeader from "./header/EyeTestHeader";

interface EyeTestWrapperProps {
  locale: string;
  slug: string;
  pageContent?: BookEyeTestContent;
  selectedServiceType?: EyeTestServiceType;
  serviceId?: number; // ADD: Accept serviceId
  stores: StoreType[];
  storeDetails?: StoreType;
  translations?: TranslationData;
  bookingDetails?: BookingDetails;
  holidays?: Date[];
  onCancelBooking?: () => void;
}

const EyeTestWrapper = ({
  locale,
  slug,
  pageContent,
  selectedServiceType,
  serviceId, // ADD: Extract serviceId
  stores,
  storeDetails,
  translations,
  bookingDetails,
  holidays,
  onCancelBooking,
}: EyeTestWrapperProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const layoutRef = useRef<BookEyeTestLayoutRef>(null);

  // Function to be called by header when cross icon is clicked on success page
  const handleHeaderCancelClick = () => {
    if (slug === "success" && layoutRef.current) {
      layoutRef.current.triggerCancelModal();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      slots={{
        close: { visible: false },
        root: { className: "px-0 no-scrollbar isolate z-[25]" },
        container: { className: "w-full overflow-y-scroll no-scrollbar h-screen" },
      }}
    >
      <EyeTestHeader
        slug={slug}
        translations={translations?.bookEyeTest}
        title={pageContent?.title}
        setIsOpen={setIsOpen}
        onCancelBooking={slug === "success" ? handleHeaderCancelClick : undefined}
      />
      <BookEyeTestLayout
        ref={layoutRef}
        slug={slug}
        locale={locale}
        stores={stores}
        bookingDetails={bookingDetails}
        holidays={holidays}
        pageContent={pageContent}
        selectedServiceType={selectedServiceType}
        serviceId={serviceId} // ADD: Pass serviceId
        storeDetails={storeDetails}
        translations={translations}
      />
    </Modal>
  );
};

export default EyeTestWrapper;
